// extracted by mini-css-extract-plugin
export default {"subHeader":"styles-module__subHeader__c560766faa587948f8dc","default":"styles-module__default__b7278d0adef751ca3008","green":"styles-module__green__cc3f5bd8ea88a2fe248e"};